import React from 'react'
import PropTypes from 'prop-types'
import TopFeatures from '../../components/TopFeatures/TopFeatures'
import appleVictory from 'media/apple-victory.png'
import MealPlansPageReviews from '../MealPlansPage/MealPlansPageReviews'
import AggregateRating from '../../components/AggregateRating/AggregateRating'
import { FormattedMessage } from 'react-intl'

function MealPlansPageAppPromo({ topFeatures }) {
  return (
    <>
      <section className="mx-auto w-full max-w-968 px-32 pb-64 pt-80">
        <div className="mb-24 flex justify-center" style={{ height: '175px' }}>
          <img src={appleVictory} width="200" />
        </div>
        <h1 className="mb-36 text-center type-40 lg:type-56">
          <FormattedMessage
            id="upgrade.checklist_heading"
            defaultMessage="Full access to the tools you need to <b>crush</b> your health goals."
            values={{
              b: function Bold(...chunks) {
                return <b className="font-bold">{chunks}</b>
              },
            }}
          />
        </h1>
        <TopFeatures features={topFeatures} />
      </section>
      <AggregateRating />
      <MealPlansPageReviews />
    </>
  )
}

MealPlansPageAppPromo.propTypes = {
  topFeatures: PropTypes.array,
}

export default MealPlansPageAppPromo
